import { render, staticRenderFns } from "./RecentPerformance.vue?vue&type=template&id=1bb75669&"
import script from "./RecentPerformance.vue?vue&type=script&lang=js&"
export * from "./RecentPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports